

export const NAMESPACE_YUESAO_SERVE = 'yuesaoServe'

import { PREFIX_SOPERATION_API } from '@/service'

export const API = {
  // 【月嫂端】查询月嫂是否已绑定订单
  URL_QUERY_BIND_ORDER: `${PREFIX_SOPERATION_API}workerLog/queryBindOrder.do`,
  // 【月嫂端】月嫂绑定订单
  URL_BIND_ORDER: `${PREFIX_SOPERATION_API}workerLog/bindOrder.do`,
  // 【月嫂端】根据用户手机号查是否有效月嫂订单
  URL_QUERY_YUESAO_ORDER: `${PREFIX_SOPERATION_API}workerLog/queryYueSaoOrder.do`,
  // 【月嫂端】月嫂解除绑定订单
  URL_UNBIND_ORDER: `${PREFIX_SOPERATION_API}workerLog/unBindOrder.do`,
  // 【月嫂端】月嫂上传日志新增，编辑接口
  URL_UPLOAD_LOG: `${PREFIX_SOPERATION_API}workerLog/saveWorkerLog.do`,
  // 【月嫂端】根据订单号查日志详情
  URL_QUERY_LOG_DETAIL: `${PREFIX_SOPERATION_API}workerLog/queryLogDetail.do`,
  // 【会员端】根据日期查月嫂日志详情
  URL_QUERY_MEMBER_LOG_DETAIL: `${PREFIX_SOPERATION_API}userBigService/queryServiceLogDetail.do`,
  // 【基础数据】基础数据获取首次惊喜时刻
  URL_QUERY_BASE_DATA: `${PREFIX_SOPERATION_API}workerLog/queryBaseData.do`,
  //【基础数据】根据订单号查订单数据，已上传天数
  URL_QUERY_ORDER_DATA: `${PREFIX_SOPERATION_API}workerLog/queryDataByOrderId.do`,
  // 【基础数据】根据订单号查雇主信息
  URL_QUERY_EMPLOYER_INFO: `${PREFIX_SOPERATION_API}workerLog/queryUserInfoByOrderId.do`
}
